import React__default, { useState, useEffect } from 'react';
import { LegacyButton } from '../../navigation/LegacyButton/Button.es.js';
import { Icon } from '../Icon/Icon.es.js';

const root = "_root_1as8n_1";
const summary = "_summary_1as8n_15";
const content = "_content_1as8n_41";
const arrow = "_arrow_1as8n_61";
const fullPageButton = "_full-page-button_1as8n_74";
const styles = {
	root: root,
	summary: summary,
	content: content,
	arrow: arrow,
	fullPageButton: fullPageButton
};

const Accordion = ({ children, href, isInitiallyOpen = false, onToggle, title, toggleSide = "left", isOpen }) => {
  const [openState, setOpenState] = useState(Boolean(isInitiallyOpen));
  useEffect(() => {
    if (isOpen !== void 0) {
      setOpenState(isOpen);
    }
  }, [isOpen]);
  return React__default.createElement(
    "details",
    { "data-toggle-side": toggleSide, className: styles.root, open: openState, "data-zds": true },
    React__default.createElement(
      "summary",
      { "data-toggle-side": toggleSide, className: styles.summary, onClick: (event) => {
        event.preventDefault();
        if (onToggle) {
          onToggle({ isOpen: !openState });
        }
        if (isOpen === void 0) {
          setOpenState(!openState);
        }
      }, "data-zds": true },
      React__default.createElement(
        "span",
        { "data-toggle-side": toggleSide, className: styles.arrow, "data-zds": true },
        React__default.createElement(Icon, { canAcceptPointerEvents: false, name: openState ? "arrowSmallUp" : "arrowSmallDown", size: 24 })
      ),
      title
    ),
    React__default.createElement("div", { "data-toggle-side": toggleSide, className: styles.content, "data-zds": true }, children),
    href && React__default.createElement(
      "div",
      { className: styles.fullPageButton, "data-zds": true },
      React__default.createElement(LegacyButton, { color: "tertiary", href, iconBefore: "arrowOffsite", isFullWidth: true, size: "medium", target: "_blank" }, "Open full page")
    )
  );
};

export { Accordion };
//# sourceMappingURL=Accordion.es.js.map
